import React from "react";
import ohlogo from '/src/assets/olympic-holidays-logo.svg';
import abtaLogo from '/src/assets/abta-logo.svg'
import atolLogo from '/src/assets/atol.png'

// Page chrome header (prototype chrome-itinerary.jsx Header): white card, logo left at 56px,
// ABTA + ATOL both 44px with the phone/opening hours on the right. Stacks and centres on
// mobile (≤768px) with smaller badges rather than hiding them.
const Header = () => {
    return (
        <header className="relative z-50 mb-[18px]">
            <div className="bg-white rounded-card shadow-card">
                <div className="flex flex-col md:flex-row items-center justify-between px-3.5 py-3.5 md:px-9 md:py-5 gap-2.5 md:gap-4">
                    <a href={window.wwwUrl} className="flex items-center">
                        <img src={ohlogo} alt="Olympic Holidays Logo" className="h-[56px] w-auto" />
                    </a>
                    <div className="flex items-center flex-wrap justify-center gap-3 md:gap-[22px] text-center md:text-left">
                        <img src={abtaLogo} alt="ABTA — Travel with confidence" className="h-8 md:h-[44px] w-auto" />
                        <img src={atolLogo} alt="ATOL Protected" className="h-8 md:h-[44px] w-auto" />
                        <div className="whitespace-nowrap">
                            <div className="text-secondary text-lg">020 8492 6868</div>
                            <div className="text-content_3 text-[13px]">Open 9AM to 7PM today</div>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
};
export default Header;
